import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IconGift } from '../../elements/Icon';

const WEEK_DAYS = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];

function getLast9Days() {
  const result = [];
  const today = new Date();

  for (let i = 8; i >= 0; i--) {
    const d = new Date(today);
    d.setUTCDate(today.getUTCDate() - i);

    result.push({
      key: d.toISOString().split('T')[0],
      day: d.getUTCDate(),
      weekDay: WEEK_DAYS[d.getUTCDay()],
    });
  }

  return result;
}

export const Gift = ({ onClose, days }) => {
  const { t } = useTranslation();

  const profile = JSON.parse(localStorage.getItem('profile') || '{}');

  const dailyGift = profile?.dailyGift || {};

  const last9Days = useMemo(() => {
    const dates = getLast9Days();

    return dates.map((item, index) => {
      const value = dailyGift[item.key] || 0;

      return {
        ...item,
        value,
        enabled: !!dailyGift[item.key],
        weekDay: item.weekDay,
      };
    });
  }, [dailyGift]);

  return (
    <div
      onClick={onClose}
      className="w-full h-full absolute z-[60] bg-black/30 flex justify-center items-center"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="
          relative
          xl:w-[896px] lg:w-[656px] md:w-[540px] w-[516px]
          xl:h-[466px] lg:h-[336px] md:h-[283px] h-[265px]
          rounded-[19px]
          border-[4px]
          border-[#7743BA]
          bg-[#F8F4EA]
          shadow-xl
        "
      >
        <div className="flex justify-center items-center gap-2
        xl:mt-[35px] lg:mt-[20.5px] md:mt-[23px] mt-[10px]
        xl:mb-[83px] lg:mb-[60.5px] md:mb-[44px] mb-[42px]
        ">
          <h2 className="
            text-[#4B96C9]
            xl:text-[36px] lg:text-[26px] md:text-[24px] text-[20px]
            text-center
            font-fredokaOne
          ">
            {days === 1
              ? t("presentPopUpOne")
              : t("presentPopUp").replace("X", days)}
          </h2>

          <IconGift
            className="xl:w-[36px] w-[24px]
                       xl:h-[36px] h-[24px] " />
        </div>

        <div
          className="
                    w-full
                    grid
                    grid-cols-[repeat(9,max-content)]
                    justify-between
                    xl:px-[40px]
                    lg:px-[28px]
                    px-[20px]
                    " >
          {last9Days.map((item, index) => (
            <div
              key={item.key}
              className="
                rounded-[6px]
                bg-[#EAE7ED]
                flex
                flex-col
                items-center
                xl:w-[72px] lg:w-[50px] md:w-[43px] w-[44px]
                xl:h-[260px] lg:h-[192px] md:h-[163px] h-[168px] 
              "
            >
              <span className="
                text-[14px]
                font-semibold
                text-[#7743BA]
                xl:mt-[16.5px] mt-[10.5px]
              ">
                {item.weekDay}
              </span>

              <div
                className={`
                  xl:mt-[14px] md:mt-[8.5px] mt-[9.5px]
                  xl:w-[40px] lg:w-[32px] w-[31px]
                  xl:h-[40px] lg:h-[32px] h-[31px]
                  rounded-[4px]
                  flex
                  items-center
                  justify-center
                  text-white
                  font-bold
                  text-[14px]
                  xl:text-[20px]
                  ${item.enabled
                    ? 'bg-[#7743BA]'
                    : 'bg-[#BAA8D2]'}
                `}
              >
                {item.day}
              </div>

              <div
                className={`
                xl:mt-[80px] lg:mt-[54px] mt-[36px]
                  flex
                flex-col
                items-center
                `}
              >
                <IconGift className="xl:w-[44px] lg:w-[33px] w-[27px]" />


                <span
                  className={`
                  xl:mt-[14.5px] md:mt-[8.5px] mt-[9.5px]
                  text-[14px]
                  xl:text-[16px]
                  font-semibold
                  ${item.enabled
                      ? 'text-[#7743BA]'
                      : 'text-[#BAA8D2]'}
                `}
                >
                  {item.value}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
